export enum UserAction 
{
  SORT = 'Sort',
  FILTER = 'Filter',
  PAGE_CHANGED = 'Page Changed', 
  BUTTON_CLICKED = 'Button Clicked',  
  LINK_CLICKED = 'Link Clicked',
  TAB_CLICKED = "Tab Clicked",
  REPORT_ITEM_CLICKED = "Report Item Clicked",
  }
  